import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// ── Design token system (cascade order matters — tokens first) ──────
import './styles/tokens.css'        // 1st: :root variables, reset, body
import './styles/app-shell.css'     // 2nd: shared chrome (header, buttons, toasts)
import './styles/states.css'        // 3rd: loading/error/confirm states
import './styles/file.css'          // 4th: shared styles (btn-badge used by V2)
import './styles/node.css'          // 5th: block modal styles (BlockInputModal used by V2)
import './styles/bottom-panel.css' // 6th: bottom-docked panel shell (BottomPanel)
import './styles/node-v2.css'       // 7th: V2 node/block editor
import './styles/settings.css'      // 8th: modals, data source wizard
import './styles/timeline-node.css' // 9th: timeline node view
import './styles/login.css'         // 10th: login page
import './styles/conflicts.css'     // 11th: conflict inbox + resolve view

import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
